import React, { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { EmployeeSalaryAdjustmentsInfoItem } from 'bus/employeeSalaryAdjustments/types';
import { isSuccess } from 'utils/responseStatus';
import { useLazyGetEmployeeSalaryAdjustmentsInfoQuery } from 'bus/employeeSalaryAdjustments/employeeSalaryAdjustments';
import { BlockAdjustmentInfo, BlockAdjustmentTable } from './components';
import { AppLayoutTop } from 'components/appComponents';


const EmployeeAdjustmentsDetail: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [getInfo] = useLazyGetEmployeeSalaryAdjustmentsInfoQuery();

  const [form, setForm] = useState<EmployeeSalaryAdjustmentsInfoItem>({
    comment: '',
    date: '',
    driverName: '',
    sum: 0
  });

  const getEmployeeSalaryAdjustmentsInfo = useCallback(async () => {
    const res = await getInfo({ id });
    if (isSuccess(res)) {
      const data: any = 'data' in res ? (res as any).data : (res as any);
      setForm(data);
    }
  }, [getInfo, id]);

  useEffect(() => {
    getEmployeeSalaryAdjustmentsInfo();
  }, [
    getEmployeeSalaryAdjustmentsInfo
  ]);

  return (
    <div>
      <AppLayoutTop title="Корректировка зарплат" />
      <BlockAdjustmentInfo
        form={form}
      />
      <BlockAdjustmentTable
        adjustmentId={id}
        refreshDetail={getEmployeeSalaryAdjustmentsInfo}
      />
    </div>
  );
}

export default EmployeeAdjustmentsDetail;